exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".appMargin0[data-v-22035596]{margin-left:0!important;margin-right:100px;transition:5s!important}.modal fade show d-block[data-v-22035596]{background:none}.btn-outline-danger[data-v-22035596],.btn-outline-success[data-v-22035596]{margin-bottom:.5rem}@media (max-width:944px){.md-flex-small-100[data-v-22035596]{margin-top:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22035596","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/viewMainEnquiryDetails.vue
// module id = 1445
// module chunks = 0